jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});
document.addEventListener('scroll', function() {
  var body = document.querySelector('body');
  if (window.scrollY > 100) { // Adjust this value as needed
    body.classList.add('is-sticky');
    body.classList.remove('is-not-sticky');
  } else {
    body.classList.add('is-not-sticky');
    body.classList.remove('is-sticky');
  }
});
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const sidebarMenu = document.querySelector('.t4s-product-categories');
    if (!sidebarMenu) return; // No sidebar menu found

    const allParents = sidebarMenu.querySelectorAll('li.menu_nested');
    
    allParents.forEach(function(parentItem) {
      const subMenu = parentItem.querySelector('ul.sub-menu');
      const toggleButton = parentItem.querySelector('.btn_cats_toggle');

      if (subMenu && toggleButton) {
        // Collapse all submenus initially
        subMenu.classList.add('dn');

        // Setup toggle click
        toggleButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = !subMenu.classList.contains('dn');

          // Collapse all other submenus
          allParents.forEach(function(otherParent) {
            const otherSub = otherParent.querySelector('ul.sub-menu');
            if (otherSub) {
              otherSub.classList.add('dn');
            }
          });

          // Toggle current submenu
          if (isOpen) {
            subMenu.classList.add('dn'); // Collapse if already open
          } else {
            subMenu.classList.remove('dn'); // Expand if closed
          }
        });
      }
    });

    // Auto-open the active parent menu
    const activeCategory = sidebarMenu.querySelector('li.t4s-current-cat');
    if (activeCategory) {
      const activeSubMenu = activeCategory.querySelector('ul.sub-menu');
      if (activeSubMenu) {
        activeSubMenu.classList.remove('dn'); // Open active category
      }
    }

  }, 300); // slight delay to make sure sidebar is fully rendered
});
